import countries from './data/geocode/countries.json';
import states from './data/geocode/states.json';

export const geocodeAPI = {
  getCountries() {
    return Object.values(countries).sort((countryA, countryB) => {
      return countryA.name.localeCompare(countryB.name);
    });
  },
  getCountry(countryCode = "USA") {
    return countries[countryCode];
  },
  getStates(countryCode = "USA") {
    if (countryCode === "USA") {
      return states;
    }

    return [];
  }
}